<!-- Page Header -->
<app-page-header></app-page-header>

<!-- Search Layout Integration -->
<div class="container py-2">
  <div class="row">
    <!-- Search Section (Full Width on Search Page) -->
    <div class="col-12">
      <div class="card border-0 shadow-sm mb-3 search-card">
        <div class="card-header text-white"
          style="background-image: url('/assets/images/banner-main.png'); background-size: cover; background-position: center; border-radius: 8px 8px 0 0;">
          <h5 class="mb-0 text-white">
            <i class="fas fa-search me-2"></i>
            {{ 'SEARCH_TITLE' | translate }}
          </h5>
        </div>
        <div class="card-body">
          <div class="search-form">

            <!-- Search Scope Selection -->
            <div class="mb-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="searchScope" id="scopeAll" [value]="0"
                  [(ngModel)]="searchScope">
                  <label class="form-check-label" for="scopeAll">{{ 'SEARCH_SCOPE_ALL' | translate }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="searchScope" id="scopeJournals" [value]="3"
                    [(ngModel)]="searchScope">
                    <label class="form-check-label" for="scopeJournals">{{ 'SEARCH_SCOPE_JOURNALS' | translate }}</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="searchScope" id="scopeArticles" [value]="1"
                      [(ngModel)]="searchScope">
                      <label class="form-check-label" for="scopeArticles">{{ 'SEARCH_SCOPE_ARTICLES' | translate }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" name="searchScope" id="scopeBooks" [value]="2"
                        [(ngModel)]="searchScope">
                        <label class="form-check-label" for="scopeBooks">{{ 'SEARCH_SCOPE_BOOKS' | translate }}</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="searchScope" id="scopeAuthors" [value]="4"
                          [(ngModel)]="searchScope">
                          <label class="form-check-label" for="scopeAuthors">{{ 'SEARCH_SCOPE_AUTHORS' | translate }}</label>
                        </div>
                      </div>

                      <div class="input-group input-group-lg">
                        <input type="text" class="form-control" [(ngModel)]="quickSearchQuery"
                          [placeholder]="'SEARCH_PLACEHOLDER' | translate" (keyup.enter)="navigateForQuickSearch()">
                          <button class="btn btn-primary" type="button" (click)="navigateForQuickSearch()" style="background-color: #758564; border-color: #758564;">
                            <i class="fas fa-search text-white"></i>
                          </button>
                        </div>

                        <div class="mt-3 text-end">
                          <a href="javascript:void(0)" (click)="toggleAdvancedSearch()" class="text-primary" style="color: #758564 !important;">
                            <i class="fas fa-sliders-h me-1"></i>
                            {{ 'ADVANCED_SEARCH_TOGGLE' | translate }}
                            <i class="fas ms-1" [ngClass]="showAdvancedSearch ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Advanced Search Collapsible Section -->
                  <div class="advanced-search-collapse" [class.show]="showAdvancedSearch">
                    <div class="card border-0 shadow-sm mt-3 mb-4">
                      <div class="card-body">
                        <app-advanced-search [isEmbedded]="true" [parentScope]="searchScope"></app-advanced-search>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Statistics Section (Optional, can be used for search summary) -->
            <section class="page-header page-header-classic no-margin py-3 mb-4"
              style="background-image: url('/assets/images/banner-main.png'); background-size: cover; background-position: center; background-repeat: no-repeat;">
              <div class="container text-white">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 class="mb-1 text-white">{{ 'SEARCH_RESULTS_TITLE' | translate }}</h4>
                    @if (!loading) {
                      <p class="mb-0 text-white-50">
                        {{ metadata.TotalResults }} {{ 'SEARCH_RESULTS_FOUND' | translate }}
                        <span class="ms-2">({{ metadata.SearchTime }}ms)</span>
                      </p>
                    }
                  </div>
                  <div class="text-white-50 small">
                    <i class="fas fa-info-circle me-1"></i>
                    {{ 'SEARCH_QUERY_RESULTS' | translate: { query: metadata.Query } }}
                  </div>
                </div>
              </div>
            </section>

            <div class="container py-2">

              <!-- Loading State -->
              @if (loading) {
                <div class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">{{ 'LOADING' | translate }}</span>
                  </div>
                  <p class="mt-3 text-muted">{{ 'SEARCHING' | translate }}</p>
                </div>
              }

              <!-- Results -->
              @if (!loading) {
                <div class="row">
                  <!-- Facets/Filters Sidebar -->
                  @if (facets && facets.length > 0) {
                    <div class="col-md-3">
                      <div class="card shadow-sm mb-4">
                        <div class="card-header bg-light">
                          <h6 class="mb-0">{{ 'REFINE_RESULTS' | translate }}</h6>
                        </div>
                        <div class="card-body">
                          @for (facetGroup of facets; track facetGroup) {
                            <div class="mb-4">
                              <h6 class="text-secondary mb-2">{{ facetGroup.Title }}</h6>
                              <div class="facet-items">
                                @for (item of facetGroup.Items; track item) {
                                  <div class="form-check">
                                    <input
                                      class="form-check-input"
                                      type="checkbox"
                                      [id]="'facet-' + item.ID"
                                      [checked]="item.Selected">
                                      <label class="form-check-label" [for]="'facet-' + item.ID">
                                        {{ item.Label }}
                                        <span class="badge bg-secondary ms-1">{{ item.Count }}</span>
                                      </label>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    <!-- Results List -->
                    <div [class]="facets && facets.length > 0 ? 'col-md-9' : 'col-12'">
                      <!-- Tabs for Content Types -->
                      @if (contentTypeResults.length > 1) {
                        <ul class="nav nav-tabs mb-3">
                          @for (res of contentTypeResults; track res) {
                            <li class="nav-item">
                              <a class="nav-link"
                                [class.active]="currentContentType === res.ContentType"
                                (click)="switchTab(res.ContentType)"
                                href="javascript:void(0)">
                                {{ getContentTypeLabel(res.ContentType) | translate }}
                                <span class="badge rounded-pill bg-light text-dark ms-1">{{ res.TotalResults }}</span>
                              </a>
                            </li>
                          }
                        </ul>
                      }
                      <!-- No Results -->
                      @if (results.length === 0) {
                        <div class="text-center py-5">
                          <i class="fas fa-search fa-3x text-muted mb-3"></i>
                          <h5>{{ 'SEARCH_NO_RESULTS' | translate }}</h5>
                          <p class="text-muted">{{ 'SEARCH_TRY_DIFFERENT_KEYWORDS' | translate }}</p>
                        </div>
                      }
                      <!-- Results Items -->
                      @for (result of results; track result) {
                        <div class="card shadow-sm mb-3 result-card">
                          <div class="card-body">
                            <!-- Author Type Result -->
                            @if (result.Type === 'Author') {
                              <div class="row">
                                <div class="col-12">
                                  <!-- Author Name -->
                                  <h5 class="card-title mb-2">
                                    <a [href]="getResultUrl(result)" class="text-decoration-none text-dark d-inline-flex align-items-center" style="color: inherit !important;">
                                      <i class="fas fa-user-circle me-2" style="color: #9ca3af;"></i>
                                      <span>
                                        @if (result.AuthorTitle) {
                                          <span class="me-1">{{ result.AuthorTitle }}</span>
                                          }&nbsp;{{ result.AuthorName || result.Title }}
                                        </span>
                                      </a>
                                    </h5>
                                    <!-- Email -->
                                    @if (result.Email) {
                                      <p class="text-muted mb-2">
                                        <i class="fas fa-envelope me-2"></i>
                                        <a [href]="'mailto:' + result.Email" class="text-muted">{{ result.Email }}</a>
                                      </p>
                                    }
                                    <!-- Publication Statistics -->
                                    <div class="d-flex flex-wrap mb-2" style="gap: 8px;">
                                      @if (result.TotalArticles && result.TotalArticles > 0) {
                                        <div class="badge" style="background-color: #e8f4e8; color: #4a7c4e; font-weight: 500;">
                                          <i class="fas fa-file-alt me-1"></i>
                                          {{ result.TotalArticles }} {{ 'ARTICLES' | translate }}
                                        </div>
                                      }
                                      @if (result.TotalBooks && result.TotalBooks > 0) {
                                        <div class="badge" style="background-color: #d4e9d4; color: #3d6b3f; font-weight: 500;">
                                          <i class="fas fa-book me-1"></i>
                                          {{ result.TotalBooks }} {{ 'BOOKS' | translate }}
                                        </div>
                                      }
                                      @if (result.TotalChapters && result.TotalChapters > 0) {
                                        <div class="badge" style="background-color: #c8e0c8; color: #2f5a31; font-weight: 500;">
                                          <i class="fas fa-book-open me-1"></i>
                                          {{ result.TotalChapters }} {{ 'CHAPTERS' | translate }}
                                        </div>
                                      }
                                      @if (result.TotalSeries && result.TotalSeries > 0) {
                                        <div class="badge" style="background-color: #f0f4e8; color: #758564; font-weight: 500;">
                                          <i class="fas fa-layer-group me-1"></i>
                                          {{ result.TotalSeries }} {{ 'SERIES' | translate }}
                                        </div>
                                      }
                                      @if (result.TotalPublications && result.TotalPublications > 0) {
                                        <div class="badge" style="background-color: #e0e8d8; color: #5a6d4e; font-weight: 500;">
                                          <i class="fas fa-chart-bar me-1"></i>
                                          {{ 'TOTAL' | translate }}: {{ result.TotalPublications }}
                                        </div>
                                      }
                                    </div>
                                    <!-- View Profile Button -->
                                    <a [href]="getResultUrl(result)" class="btn btn-sm mt-2" style="background-color: #758564; border-color: #758564; color: white;">
                                      <i class="fas fa-user me-1"></i>
                                      {{ 'VIEW_PROFILE' | translate }}
                                    </a>
                                  </div>
                                </div>
                              }
                              <!-- Non-Author Type Results (Articles, Books, Journals) -->
                              @if (result.Type !== 'Author') {
                                <div class="row">
                                  <!-- Image -->
                                  @if (result.CoverImage) {
                                    <div class="col-md-2">
                                      <img
                                        [src]="'https://cdn.istanbul.edu.tr/image/JTA6CLJ8T5/' + result.CoverImage"
                                        [alt]="result.Title"
                                        class="img-fluid rounded mb-2"
                                        style="max-height: 150px; object-fit: cover;">
                                        <!-- PDF Button -->
                                        @if (result.PdfUrl) {
                                          <a [href]="getPdfUrl(result.PdfUrl)" target="_blank" class="btn btn-sm btn-outline-secondary w-100" style="font-size: 0.75rem; padding: 0.25rem 0.5rem; pointer-events: auto; transition: none; background-color: transparent !important; border-color: #6c757d !important; color: #6c757d !important;">
                                            <i class="fas fa-file-pdf me-1"></i>
                                            PDF
                                          </a>
                                        }
                                      </div>
                                    }
                                    <!-- Content -->
                                    <div [class]="result.CoverImage ? 'col-md-10' : 'col-12'">
                                      <!-- Title -->
                                      <h5 class="card-title">
                                        <a [href]="getResultUrl(result)" class="text-decoration-none text-dark" style="color: inherit !important;">
                                          {{ result.Title }}
                                        </a>
                                      </h5>
                                      <!-- Authors -->
                                      @if (result.Authors && result.Authors.length > 0) {
                                        <p class="text-muted mb-2">
                                          <i class="fas fa-user-edit me-3"></i>
                                          {{ result.Authors.join(', ') }}
                                        </p>
                                      }
                                      <!-- Publication Info -->
                                      <div class="text-muted mb-2">
                                        <!-- Journal Name -->
                                        @if (result.JournalName) {
                                          <div class="mb-1">
                                            <i class="fas fa-book-open me-3"></i>
                                            <span class="text-dark fw-medium">{{ result.JournalName }}</span>
                                          </div>
                                        }
                                        <!-- Book Name -->
                                        @if (result.BookName && result.Type !== 'Book') {
                                          <div class="mb-1">
                                            <i class="fas fa-book me-3"></i>
                                            <span class="text-dark fw-medium">{{ result.BookName }}</span>
                                          </div>
                                        }
                                        <div class="d-flex flex-wrap gap-x-3">
                                          <!-- Date/Year -->
                                          @if (result.PublishDate || result.Year) {
                                            <div class="me-4">
                                              <i class="fas fa-calendar-alt me-3"></i>
                                              @if (result.PublishDate) {
                                                <span>{{ result.PublishDate | date:'dd.MM.yyyy' }}</span>
                                              }
                                              @if (!result.PublishDate && result.Year) {
                                                <span>{{ result.Year }}</span>
                                              }
                                            </div>
                                          }
                                          <!-- Identifiers -->
                                          @if (result.DOI) {
                                            <div class="me-4">
                                              <i class="fas fa-link me-3"></i>
                                              DOI: {{ result.DOI }}
                                            </div>
                                          }
                                          <!-- Book Specific Info (ISBN) -->
                                          @if (result.ISBN || result.EISBN) {
                                            <div class="me-4">
                                              <i class="fas fa-barcode me-3"></i>
                                              ISBN: {{ result.ISBN || result.EISBN }}
                                            </div>
                                          }
                                          <!-- Journal Specific Info (ISSN) -->
                                          @if (result.ISSN || result.EISSN) {
                                            <div class="me-4">
                                              <i class="fas fa-barcode me-3"></i>
                                              ISSN: {{ result.ISSN || result.EISSN }}
                                            </div>
                                          }
                                        </div>
                                      </div>
                                      <!-- Abstract/Snippet -->
                                      @if (result.Abstract || result.Description) {
                                        <p class="card-text mb-2">
                                          {{ stripHtml(result.Abstract || result.Description) | slice:0:300 }}
                                          @if (stripHtml(result.Abstract || result.Description).length > 300) {
                                            <span>...</span>
                                          }
                                        </p>
                                      }
                                      <!-- Keywords -->
                                      @if (result.Keywords && result.Keywords.length > 0) {
                                        <div class="mb-2">
                                          @for (keyword of result.Keywords; track keyword) {
                                            <span class="badge bg-light text-dark me-1">
                                              {{ keyword }}
                                            </span>
                                          }
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                          <!-- Pagination -->
                          @if (currentTotalPages > 1) {
                            <nav aria-label="Search results pagination">
                              <ul class="pagination justify-content-center">
                                <li class="page-item" [class.disabled]="currentPage === 1">
                                  <a class="page-link" (click)="goToPage(currentPage - 1)" href="javascript:void(0)">
                                    <i class="fas fa-chevron-left"></i>
                                  </a>
                                </li>
                                @for (page of [].constructor(currentTotalPages); track page; let i = $index) {
                                  <li
                                    class="page-item"
                                    [class.active]="currentPage === (i + 1)">
                                    <a class="page-link" (click)="goToPage(i + 1)" href="javascript:void(0)">
                                      {{ i + 1 }}
                                    </a>
                                  </li>
                                }
                                <li class="page-item" [class.disabled]="currentPage === currentTotalPages">
                                  <a class="page-link" (click)="goToPage(currentPage + 1)" href="javascript:void(0)">
                                    <i class="fas fa-chevron-right"></i>
                                  </a>
                                </li>
                              </ul>
                            </nav>
                          }
                        </div>
                      </div>
                    }
                  </div>
